import React from 'react'

export const ForgotPassword = () => {
	return <div>forgotPassword</div>
}
